const FeatureItem = ({ enabled, label }) => (
    <p className={`text-sm ${enabled ? "" : "line-through text-gray-400"}`}>
      {label}
    </p>
  );
  
  export default FeatureItem;
  